import { render, staticRenderFns } from "./CustomerChanges.vue?vue&type=template&id=7d1bf0ce"
import script from "./CustomerChanges.vue?vue&type=script&lang=js"
export * from "./CustomerChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports